import {SignalREvent, SignalRHub} from 'constants/dataEnum';
import {invokeAPI} from 'stores/business/commonBusiness';
import GlobalReduxStore from 'stores/globalReduxStore';

export const isUserBusy = async (username) => {
  const {dispatch} = GlobalReduxStore.getStore();
  let response;

  try {
    response = await dispatch(invokeAPI(SignalRHub.SESSION, SignalREvent.IS_USER_BUSY, username));
  } catch (error) {
    console.error('error in isUserBusy API', error);
  }
  return response;
};

export const _doNotUse = () => {};
